import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { RfiService } from '@/app/services/rfi/rfi.service';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { ActivatedRoute } from '@angular/router';
import { TimeAgoService } from '@/app/services/time-ago/time-ago.service';

interface Comment {
  isEditing?: boolean;
  isReplying?: boolean;
  comment: string;
  replies?: Comment[];
}
@Component({
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    MatIconModule,
  ],
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.css'],
})
export class CommentsComponent implements OnInit {
  comments: any;
  user_info: any = localStorage.getItem('user_info')
    ? JSON.parse(localStorage.getItem('user_info') as string)
    : null;
  rfiId: number;
  newComment = '';
  replyContent: string;

  constructor(
    private readonly rfiService: RfiService,
    private readonly getProjectIdService: GetProjectIdService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly timeAgoService: TimeAgoService
  ) {}

  ngOnInit() {
    this.rfiId = +this.activatedRoute.snapshot.paramMap.get('rfiId')!;
    this.getRfiComments();
  }
  addComment() {
    if (!this.newComment.trim()) return;
    const newComment: Comment = {
      comment: this.newComment,
    };

    this.comments.push(newComment);
    this.addRfiComment(newComment);
    this.newComment = '';
  }

  deleteComment(commentId: number) {
    this.deleteRfiComment(commentId);
  }

  editComment(comment: Comment) {
    comment.isEditing = true;
  }

  saveComment(comment: Comment) {
    comment.isEditing = false;
    this.updateRfiComment(comment);
  }
  replyToComment(comment: Comment) {
    comment.isReplying = true;
  }
  addReply(parentComment: any) {
    const replyText = this.replyContent?.trim();
    if (!replyText) return;
    const reply: Comment = {
      comment: replyText,
    };
    parentComment.isReplying = false;
    this.replyRfiComment(reply, parentComment?.id);
  }
  getRfiComments(): any {
    return this.rfiService.getRfiComments(this.rfiId).subscribe({
      next: (data: any) => {
        if (data?.meta?.success) {
          this.comments = data?.data;
        }
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      },
    });
  }
  addRfiComment(data: any): any {
    return this.rfiService.addRfiComment(data, this.rfiId).subscribe({
      next: (data: any) => {
        if (data?.meta?.success) {
          this.getRfiComments();
        }
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      },
    });
  }

  deleteRfiComment(commentId: number): any {
    return this.rfiService.deleteRfiComment(this.rfiId, commentId).subscribe({
      next: (data: any) => {
        if (data?.meta?.success) {
          this.getRfiComments();
        }
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      },
    });
  }
  updateRfiComment(comment: any): any {
    return this.rfiService
      .updateRfiComment(comment, this.rfiId, comment?.id)
      .subscribe({
        next: (data: any) => {
          if (data?.meta?.success) {
            this.getRfiComments();
          }
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        },
      });
  }
  replyRfiComment(reply: any, commentId: number): any {
    return this.rfiService
      .replyRfiComment(reply, this.rfiId, commentId)
      .subscribe({
        next: (data: any) => {
          if (data?.meta?.success) {
            this.getRfiComments();
          }
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        },
      });
  }
  getTimeAgo(date: string): string {
    return this.timeAgoService.timeAgo(date);
  }
}
